"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELIMITER_PATH = '/';
exports.DELIMITER_URL_PARTS = '?';
exports.DELIMITER_SEARCH_PARAMS = '&';
exports.DELIMITER_SEARCH_VALUES = '=';
